<template>
    <div class="tabs">
        <slot name="tabsNav" :currentTab="currentTab" :goToTab="goToTab" :labels="labels"/>

        <div class="tabs__content">
            <slot />
        </div>
    </div>
</template>

<script>
import useTabs from './use-tabs';
import { provide, ref } from 'vue';

export default {
    name: "Tabs",

    props: {
        initialTab: {
            type: String,
            default: () => '',
        },
        labels: {
            type: Array,
            default: () => ([])
        }
    },
    setup(props) {
        const { currentTab, goToTab } =  useTabs({
            resetBeforeEnter: true,
            initialTab: props.initialTab
        });

        const refCurrentTab = ref(currentTab);

        provide('currentTab', refCurrentTab)

        return {
            goToTab,
            currentTab,
        };
    }
}
</script>
